$(document).ready(function () {
  $('.slideitem').click(function(){
    $('.slideitem').removeClass("current-slide");
    $(this).addClass("current-slide");
});
 let variantContt = $('.custom-varinat-input-name:checked').attr('variantcount');
$("#product-variant-count").text(variantContt);

$(".custom-varinat-input-name").click(function () {
  let variantCont = $(this).attr('variantcount'); // use $(this) to get the clicked element
  $("#product-variant-count").text(variantCont);
});
     $(document).on('click','.landing-checkout-button',function(e){
        var data = $(this).parents('form').serialize();
        $.ajax({
          type: 'POST',
          url: '/cart/add',
          data: data,
          quantity: 1,
          dataType: 'html',
          success: function(response) {
          window.location.href = "/checkout";
          },
          error: function(jqXHR, textStatus, errorThrown) {
            console.log("AJAX Error:", textStatus, errorThrown);
          }
        });
     }); 
});
